<!-- Chat renders one sanitized HTML fragment, unchanged. A report renders the same Markdown
     typography plus native chart blocks, so links, tables and headings stay identical. -->
<div *ngIf="!charts" [innerHTML]="html"></div>
<div *ngIf="charts" class="br-report">
  <ng-container *ngFor="let seg of segments; trackBy: trackSegment">
    <div *ngIf="seg.kind === 'html'" [innerHTML]="seg.html"></div>
    <div *ngIf="seg.kind === 'chart'" class="br-report__chart">
      <canvas baseChart [type]="seg.type" [data]="seg.data" [options]="seg.options" role="img" [attr.aria-label]="seg.label">{{ seg.label }}</canvas>
    </div>
    <p *ngIf="seg.kind === 'error'" role="alert" class="br-report__chart-error br-text-danger">{{ seg.message }}</p>
  </ng-container>
</div>
